import { memo } from "react";

import { Box, Stack } from "@mui/material";
import { SEO, Typography } from "components";
import { useIsMobile } from "hooks";
import { i18n } from "translations";
import { rem } from "utils";

import HeaderBar from "./HeaderBar";
import LoadingOverlay from "./LoadingOverlay";

interface Props {
  seoTitle?: string;
  seoTitleI18n?: string;
  title?: string;
  titleI18n?: string;
  subTitle?: string | React.ReactNode;
  subTitleI18n?: string;
  loading?: boolean;
  maxWidthInfo?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const PageContainer: React.FC<Props> = ({
  seoTitle,
  seoTitleI18n,
  title,
  titleI18n,
  subTitle,
  subTitleI18n,
  loading,
  action,
  maxWidthInfo,
  children,
}) => {
  const isMobile = useIsMobile();

  return (
    <>
      <SEO title={seoTitleI18n ? i18n.t(seoTitleI18n) : seoTitle} />
      <HeaderBar>
        <Stack
          direction={["column", "row"]}
          width="100%"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
        >
          <Stack maxWidth={maxWidthInfo || "70%"}>
            <Typography variant="h1" type="DisplaySM" fontWeight={600}>
              {titleI18n ? i18n.t(titleI18n) : title}
            </Typography>
            {(subTitle || subTitleI18n) && (
              <Typography fontWeight={400} type="TextSM" color="grey.600">
                {subTitleI18n ? i18n.t(subTitleI18n) : subTitle}
              </Typography>
            )}
          </Stack>

          {action && (
            <Box width="fit-content" sx={{ "& >div": { rowGap: "12px" } }}>
              {action}
            </Box>
          )}
        </Stack>
      </HeaderBar>
      <LoadingOverlay loading={loading}>
        <Box width="100%" marginTop={isMobile ? "0px" : rem(4)}>
          {children}
        </Box>
      </LoadingOverlay>
    </>
  );
};

export default memo(PageContainer);
